<!--
 * @Author: WGL
 * @Date: 2023-10-31 10:15:08
 * @LastEditors: WGL 958897276@qq.com
 * @LastEditTime: 2026-01-22 17:49:44
 * @Description: 
-->
<template>
  <el-tooltip
    content="开启会议"
    effect="dark"
    :persistent="false"
    placement="bottom"
  >
    <a :href="meetingUrl" target="_blank">
      <vab-icon
        icon="icon-yuanchenglianjie-wuzhuangtai"
        is-custom
        @click="click"
      />
    </a>
  </el-tooltip>
</template>

<script>
  import { computed, defineComponent } from 'vue'

  export default defineComponent({
    name: 'VabMeeting',
    setup() {
      const meetingUrl = computed(() => {
        return 'https://meet.jinweinet.com/'
      })
      const click = () => {}

      return {
        click,
        meetingUrl,
      }
    },
  })
</script>
